// extracted by mini-css-extract-plugin
module.exports = {"b1nf258u":"b1nf258u"};